import { render, staticRenderFns } from "./GBClasses.vue?vue&type=template&id=78a02f65&"
import script from "./GBClasses.vue?vue&type=script&lang=js&"
export * from "./GBClasses.vue?vue&type=script&lang=js&"
import style0 from "./GBClasses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports